export const environment = {
  production: true,
  recaptcha: {
    siteKey: "6LfXKcQiAAAAAHIi-VboiJll1TNXdQHxp-nlece1",
  },
};
